import gql from 'graphql-tag';

export const GET_SETTING_VALUE = gql`
  query(
    $settingGroup: String
    $settingKey: String
  ) {
    GetSettingValue(
      settingGroup: $settingGroup
      settingKey: $settingKey
    ) {
      setting_value
    }
  }
`;

export const GET_SETTING_VALUE_AUTH = gql`
  query{
    GetSettingValueAuth{
      lineSetting,
      reserveSetting,
      chatboxSetting,
      memberCodeNotSetting
    }
  }
`;
